var _g, _rect, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNoticeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 48095605"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 87",
    filter: "url(#filter0_d_3012_114041)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 24,
    fill: "#88CCC3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3012_114041",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 8,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3012_114041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M31.9979 25.769L21.5132 36.2536C21.2722 36.4947 20.9806 36.6184 20.6383 36.6248C20.296 36.6312 19.9979 36.5075 19.7441 36.2536C19.4902 35.9998 19.3633 35.705 19.3633 35.3691C19.3633 35.0332 19.4902 34.7383 19.7441 34.4845L30.2287 23.9998L19.7441 13.5152C19.503 13.2742 19.3793 12.9825 19.3729 12.6402C19.3665 12.2979 19.4902 11.9999 19.7441 11.746C19.9979 11.4922 20.2928 11.3652 20.6286 11.3652C20.9645 11.3652 21.2594 11.4922 21.5132 11.746L31.9979 22.2306L42.4825 11.746C42.7235 11.505 43.0152 11.3813 43.3575 11.3749C43.6998 11.3685 43.9978 11.4922 44.2517 11.746C44.5055 11.9999 44.6325 12.2947 44.6325 12.6306C44.6325 12.9665 44.5055 13.2614 44.2517 13.5152L33.7671 23.9998L44.2517 34.4845C44.4927 34.7255 44.6164 35.0171 44.6228 35.3594C44.6293 35.7017 44.5055 35.9998 44.2517 36.2536C43.9978 36.5075 43.703 36.6344 43.3671 36.6344C43.0312 36.6344 42.7364 36.5075 42.4825 36.2536L31.9979 25.769Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3012_114041",
    x: 0,
    y: -8,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3012_114041"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3012_114041",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoticeClose);
export default __webpack_public_path__ + "static/media/icon_notice_close.6f1446de18500306d646590992557d5d.svg";
export { ForwardRef as ReactComponent };